/* Keep a card's availability tied to the exact finish linked or selected. */
(() => {
  'use strict';
  if (window.JaccCardStock) return;

  const green = ['#176b4d', '#93c7ae', '#f0f8f4'];
  const red = ['#8b2f3c', '#d8aab0', '#fcf4f5'];
  const neutral = ['#666666', '#d6d2cc', '#fbfaf7'];
  const legacy = {
    in_stock: ['IN STOCK — READY TO SHIP', green],
    low_stock: ['IN STOCK', green, 'LOW STOCK — LIMITED AVAILABILITY'],
    last_one: ['IN STOCK', green, 'LOW STOCK — LIMITED AVAILABILITY'],
    local_stock: ['1 IN STOCK — READY TO SHIP', ['#35684a', '#c8d7cd', '#f7faf8']],
    backorder: ['BACKORDER — RESERVE YOURS NOW', red],
    special_order: ['SPECIAL ORDER - RESERVE YOURS', ['#654095', '#c1ace0', '#f8f4fd']],
    preorder: ['PRE-ORDER — RESERVE YOURS', ['#174a6e', '#a4c2d5', '#f2f7fa']],
    made_to_order: ['MADE TO ORDER', ['#8d6234', '#dac7ad', '#fcf9f4']],
    contact_for_availability: ['CONTACT FOR AVAILABILITY', neutral],
    discontinued_last_stock: ['IN STOCK', green, 'DISCONTINUED — FINAL STOCK'],
    discontinued_sold_out: ['DISCONTINUED — SOLD OUT', red],
    sold_out: ['SOLD OUT', red]
  };

  function priority(variant) {
    if (!variant || !variant.available) return 0;
    if (!variant.tracked) return 1;
    const quantity = Number(variant.quantity || 0);
    return quantity >= 5 ? 3 : quantity >= 1 ? 2 : 1;
  }

  function update(card, variant) {
    if (!card || !variant) return;
    const status = String(variant.status || '').trim().toLowerCase();
    const stockLabel = String(variant.stockLabel || '').trim();
    const isAnton = String(card.dataset.jaccMaker || '').trim().toLowerCase() === 'anton schneider';
    let [label, colors, secondary] = legacy[status] || ['', neutral, ''];
    if (status === 'backorder' && variant.comingSoon === true) {
      label = 'Pre-Order - Reserve Yours';
      colors = legacy.preorder[1];
    }
    if (isAnton && status === 'made_to_order') {
      label = 'MADE TO ORDER · 4-WEEK LEAD TIME';
    }
    if (status === 'oktoberfest_limited') {
      const count = String(card.dataset.jaccOktoberfestStock || '').trim();
      label = count ? 'ONLY ' + count + ' LEFT · OKTOBERFEST' : 'LIMITED STOCK · OKTOBERFEST';
      colors = ['#8a5d10', '#d8b86a', '#fff8e8'];
    }
    if (stockLabel) {
      label = stockLabel;
      colors = status === 'discontinued_sold_out' ? red : green;
      secondary = status === 'discontinued_last_stock' ? 'DISCONTINUED — FINAL STOCK' : '';
    }
    if (card.dataset.jaccVintage === 'true' && variant.available) {
      label = '';
      secondary = '';
    }

    card.dataset.jaccAvailability = status;
    card.dataset.jaccSelectedVariant = String(variant.id || '');
    const badge = card.querySelector('[data-jacc-card-stock]');
    const primary = card.querySelector('[data-jacc-card-stock-primary]');
    const note = card.querySelector('[data-jacc-card-stock-secondary]');
    if (badge) badge.style.display = label ? '' : 'none';
    if (primary) {
      primary.textContent = label;
      primary.style.color = colors[0];
      primary.style.borderColor = colors[1];
      primary.style.background = colors[2];
    }
    if (note) {
      note.textContent = secondary || '';
      note.style.display = secondary ? 'inline-block' : 'none';
    }
    const eventNote = card.querySelector('[data-jacc-card-stock-event]');
    if (eventNote) eventNote.style.display = status === 'oktoberfest_limited' ? '' : 'none';

    if (!variant.id) return;
    const disabled = !variant.available;
    card.querySelectorAll('product-form input[name="id"]').forEach((input) => { input.value = String(variant.id); });
    card.querySelectorAll('product-form button[type="submit"]').forEach((button) => { button.disabled = disabled; });
    card.querySelectorAll('quick-buy-modal').forEach((modal) => {
      modal.setAttribute('handle', (card.getAttribute('handle') || '') + '?variant=' + String(variant.id));
      card.querySelectorAll('button[aria-controls]').forEach((button) => {
        if (button.getAttribute('aria-controls') === modal.id) button.disabled = disabled;
      });
    });
  }

  window.JaccCardStock = { update, priority };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input?.matches?.('product-card .product-card__info input[type="radio"][data-variant-id]')) return;
    const card = input.closest('product-card');
    const script = card?.querySelector('script[data-jacc-finder-variants]');
    if (!script) return;
    try {
      const variants = JSON.parse(script.textContent || '[]');
      const variant = Array.isArray(variants) && variants.find((item) => String(item.id) === input.dataset.variantId);
      if (variant) update(card, variant);
    } catch (error) {
      // Preserve the rendered card when its variant payload is unavailable.
    }
  });
})();
